import { useMemo, useState } from "react";
import { GetOneExpeditionBoResponseDto } from "@/types/api/api-types";
import {
  AccountCard,
  AccountRate,
  PRIORITY_SERVICE_TYPES,
} from "@/components/backOffice/ratings/RatingResultCard";
import ExpressIcon from "@/assets/icons/express.svg?react";

export const FedexRateRecap = ({
  rate,
  accountId,
  accountName,
  accountNumber,
}: {
  rate: NonNullable<NonNullable<GetOneExpeditionBoResponseDto["expeditionFedexApi"]>["fedexRate"]>;
  accountId: string;
  accountName: string;
  accountNumber: string;
}) => {
  const [detailOpen, setDetailOpen] = useState(false);

  const accountRate: AccountRate = useMemo(
    () => ({
      accountId,
      accountName,
      accountNumber,
      serviceType: rate.serviceType,
      serviceName: rate.serviceName,
      rateType: rate.rateType,
      totalBaseCharge: rate.totalBaseCharge,
      totalNetCharge: rate.totalNetCharge,
      totalVatCharge: rate.totalVatCharge,
      totalDutiesAndTaxes: rate.totalDutiesAndTaxes,
      totalSurcharges: rate.totalSurcharges,
      totalFreightDiscounts: rate.totalFreightDiscounts,
      currency: rate.currency,
      surcharges: rate.surcharges,
      deliveryDate: rate.deliveryDate,
      saturdayDelivery: rate.saturdayDelivery,
    }),
    [accountId, accountName, rate, accountNumber],
  );

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2">
        <span className="text-xs font-semibold tracking-wide text-gray-500 uppercase">
          {accountName} ({accountNumber.slice(-3)}) - {rate.serviceName}
        </span>
        {PRIORITY_SERVICE_TYPES.includes(rate.serviceType) && (
          <div className={`bg-brand600 flex items-center justify-center rounded-full px-2 py-1.5`}>
            <ExpressIcon />
          </div>
        )}
      </div>
      <AccountCard
        rate={accountRate}
        isBest={false}
        isFastest={false}
        isSelected
        detailOpen={detailOpen}
        onDetailToggle={() => setDetailOpen((v) => !v)}
        onToggle={() => undefined}
      />
    </div>
  );
};
